<h2 mat-dialog-title>{{ is_edit_mode ? 'Editar plantilla' : 'Nueva plantilla' }}</h2>

<mat-dialog-content [formGroup]="form">
  <mat-form-field class="full-width">
    <mat-label>Nombre</mat-label>
    <input matInput formControlName="name" />
  </mat-form-field>

  <div class="editor-container">
    <editor
      formControlName="html_body"
      [apiKey]="tiny_mce_api_key"
      cloudChannel="6"
      id="html_body"
      [init]="tiny_mce_init"
      initialValue=""
      [inline]="false"
      tagName="div"
    ></editor>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancelar</button>
  <button mat-flat-button color="accent" type="button" [disabled]="loading() || form.invalid" (click)="save()">Guardar</button>
</mat-dialog-actions>
